import { useAuthContext } from '../../../contexts/auth';
import { DetailPage } from '../../../components/ui/detailView';
import { UserAccountDetail } from '../../../components/userAccountDetail/userAccountDetail.component';
import { LegalDocuments } from '../legalDocuments/legalDocuments.component';

export const Profile = () => {
  const { currentUser, currentUserLoading } = useAuthContext();

  if (currentUserLoading || !currentUser) {
    return <DetailPage loading />;
  }

  return (
    <UserAccountDetail user={currentUser}>
      <LegalDocuments />
    </UserAccountDetail>
  );
};
